/**
 * Sets request headers.
 * @param {Object<string,string>|{}} additionalHeaders
 * @returns {*&{"Content-Type": (string)}}
 */
export const setHeaders = (additionalHeaders = {}) => ({
  'Content-Type': 'application/json',
  ...additionalHeaders,
});
